import React, { useState } from "react";

import { DeleteOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { MdFileDownload } from "react-icons/md";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Table,
  Row,
  Col,
  DatePicker,
  Modal,
  Select,
} from "antd";
import "./invoice.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../assets/24519.png";
import sign from "../../assets/signn.png";
import PackingListPreview from "../packingList/PackingListPreview";

const Invoice = () => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [invoiceData, setInvoiceData] = useState();
  const [invoiceDate, setInvoiceDate] = useState();
  const [unit, setUnit] = useState("Quantity");
  const [typeOfDocument, setTypeOfDocument] = useState("COMMERCIAL_INVOICE");
  const [selectedCurrency, setSelectedCurrency] = useState("INR");

  const { Option } = Select;

  const onFinish = (values) => {
    setInvoiceData(values);
    setVisible(true);
  };
  const handleCancel = () => {
    setVisible(false);
  };
  const handleEditInvoice = () => {
    setVisible(false);
    if (invoiceData) {
      form.setFieldsValue(invoiceData);
    }
  };
  const handleUnitChange = (value) => {
    setUnit(value);
  };
  const printDiv = () => {
    const divToPrint = document.getElementById("print-me");
    html2canvas(divToPrint, { useCORS: true, backgroundColor: "white" }).then(
      (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const doc = new jsPDF();
        let position = 0;

        // Add the first page
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        position -= pageHeight;

        // Add additional pages if the content exceeds one page
        while (position >= -imgHeight) {
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          position -= pageHeight;
        }

        // Remove the last page if it's blank
        const pageCount = doc.internal.getNumberOfPages();
        if (pageCount > 1) {
          const lastPageContent = doc.internal.pages[pageCount];
          if (lastPageContent.length === 1) {
            doc.deletePage(pageCount);
          }
        }

        doc.save(`${invoiceData.purchaser}.pdf`);
      },
    );
  };


  const countryCurrencyList = [
    { country: "India", currency: "INR" },
    { country: "United States", currency: "USD" },
    { country: "United Kingdom", currency: "GBP" },
    { country: "United Arab Emirates", currency: "AED" },
    { country: "Saudi Arabia", currency: "SAR" },
    { country: "Germany", currency: "EUR" },
    { country: "France", currency: "EUR" },
    { country: "Canada", currency: "CAD" },
    { country: "Australia", currency: "AUD" },
    { country: "Singapore", currency: "SGD" },
    { country: "Japan", currency: "JPY" },
    { country: "China", currency: "CNY" },
  ];
  const total = (invoiceData?.users ?? []).reduce((acc, record) => {
    return acc + (record?.quantity ?? 0) * (record?.price ?? 0);
  }, 0);

  let discountAmmount = parseFloat(
    (total * ((invoiceData?.discount ?? 0) / 100))?.toFixed(2),
  );
  let igstAmmount = parseFloat(
    (total * ((invoiceData?.igst ?? 0) / 100))?.toFixed(2),
  );
  let cgstAmmount = parseFloat(
    (total * ((invoiceData?.cgst ?? 0) / 100))?.toFixed(2),
  );
  let sgstAmmount = parseFloat(
    (total * ((invoiceData?.sgst ?? 0) / 100))?.toFixed(2),
  );
  let totalTax = parseFloat(
    (igstAmmount + cgstAmmount + sgstAmmount)?.toFixed(2),
  );
  const users = invoiceData?.users ?? [];
  const dataSource = [
    ...users,
    ...Array(Math.max(0, 10 - users.length)).fill({}),
  ];


  return (
    <div>
      <h2 className="text-2xl text-cyan-900 text-center font-semibold font-serif">
        Invoice
      </h2>
      <Form
        form={form}
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        autoComplete="off"
      >
        <div className="md:px-16 ">
          <Row gutter={12} className="p-4 bg-slate-900 opacity-90 rounded-t-md">
            <Col xs={12} span={6}>
              <h3 className="text-white">Invoice Date</h3>
              <Form.Item
                name="invoiceDate"
                rules={[
                  {
                    required: true,
                    message: "Select Invoice date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  onChange={(e, timestring) => setInvoiceDate(timestring)}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Invoice No</h3>
              <Form.Item
                name="invoiceNo"
                rules={[
                  {
                    required: true,
                    message: "Select Invoice No",
                  },
                ]}
              >
                <InputNumber
                  placeholder="Invoice No"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            
            <Col xs={12} span={6}>
              <h3 className="text-white">GSTIN/Aadhaar</h3>
              <Form.Item
                name="purchaseGSTNr"
              >
                <Input placeholder="purchaser GSTN" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Invoice Type</h3>
              <Form.Item
                name="invoiceType"
                rules={[
                  {
                    required: true,
                    message: "Please select an invoice type",
                  },
                ]}
              >
                <Select
                  placeholder="Select Invoice Type"
                  style={{ width: "100%" }}
                  onChange={(value) => setTypeOfDocument(value)}
                >
                  <Option value="PACKING_LIST">PACKING LIST</Option>
                  <Option value="COMMERCIAL_INVOICE">CASH SALE INVOICE</Option>
                  <Option value="TAX_INVOICE">TAX INVOICE</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Purchaser Name</h3>
              <Form.Item
                name="purchaser"
                rules={[
                  {
                    required: true,
                    message: "Enter purchaser name",
                  },
                ]}
              >
                <Input placeholder="purchaser Name" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Purchaser Company</h3>
              <Form.Item
                name="purchaser_company"
                rules={[
                  {
                    required: true,
                    message: "Enter purchaser Company",
                  },
                ]}
              >
                <Input
                  placeholder="purchaser Company"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={12}>
              <h3 className="text-white">purchaser Address</h3>
              <Form.Item
                name="purchaserAddress"
                rules={[
                  {
                    required: true,
                    message: "Enter purchaser Address",
                  },
                ]}
              >
                <Input
                  placeholder="purchaser Address"
                  style={{ width: "44vw" }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">State</h3>
              <Form.Item
                name="purchaserState"
              >
                <Input placeholder="State" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Country</h3>
              <Form.Item
                name="purchaserCountry"
              >
                <Input placeholder="Country" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Pin Code</h3>
              <Form.Item
                name="pinCode"
              >
                <InputNumber placeholder="Pin Code" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Mobile No.</h3>
              <Form.Item
                name="mobileNo"
              >
                <InputNumber
                  placeholder="Mobile no."
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Dispatch Method</h3>
              <Form.Item
                name="DispatchMethod"
              >
                <Input
                  placeholder="Dispatch Method"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Shipment Type</h3>
              <Form.Item
                name="Shipment"
              >
                <Input placeholder="Shipment" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Port of Loading</h3>
              <Form.Item
                name="loadingPort"
              >
                <Input
                  placeholder="Port of Loading"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} span={6}>
              <h3 className="text-white">Final Destination</h3>
              <Form.Item
                name="distination"
              >
                <Input
                  placeholder="Final Destination"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {typeOfDocument !== "PACKING_LIST" ? (
              <>
                {" "}
                <Col xs={12} span={6}>
                  <h3 className="text-white">CGST(%)</h3>
                  <Form.Item name="cgst" initialValue={0}>
                    <InputNumber placeholder="CGST" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={12} span={6}>
                  <h3 className="text-white"> SGST(%)</h3>
                  <Form.Item name="sgst" initialValue={0}>
                    <InputNumber placeholder="SGST" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={12} span={6}>
                  <h3 className="text-white"> IGST(%)</h3>
                  <Form.Item name="igst" initialValue={0}>
                    <InputNumber placeholder="IGST" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={12} span={6}>
                  <h3 className="text-white">Discount(%)</h3>
                  <Form.Item name="discount" initialValue={0}>
                    <InputNumber
                      placeholder="discount"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} span={6}>
                  <h3 className="text-white">Currency</h3>

                  <Form.Item
                    name="currency"
                    initialValue="INR"
                    rules={[
                      {
                        required: true,
                        message: "Please select country & currency",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Country & Currency"
                      style={{ width: "100%" }}
                      optionFilterProp="label"
                      onChange={(value) => setSelectedCurrency(value)}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    >
                      {countryCurrencyList.map((item) => (
                        <Option
                          key={item.currency}
                          value={item.currency}
                          label={`${item.country} (${item.currency})`}
                        >
                          {item.country} ({item.currency})
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                {" "}
                <Col xs={12} span={6}>
                  <h3 className="text-white">Place of Delivery</h3>
                  <Form.Item
                    name="delivery_port"
                  >
                    <Input
                      placeholder="Dispatch Method"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} span={6}>
                  <h3 className="text-white">Place of Discharge</h3>
                  <Form.Item
                    name="dISCHARGE_port"
                  >
                    <Input
                      placeholder="Dispatch Method"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} span={12}>
                  <h3 className="text-white">Packing Information</h3>
                  <Form.Item
                    name="packing_information"
                  >
                    <Input placeholder="Shipment" style={{ width: "43.5vw" }} />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </div>

        <div className="md:px-14 ">
          <div className="p-4 bg-cyan-900 opacity-90 rounded-b-md">
            <Form.List
              name="users"
              initialValue={[{}]}
              rules={[
                {
                  validator: async (_, users) => {
                    if (users.length > 10) {
                      return Promise.reject(
                        new Error("You can add a maximum of 10 products."),
                      );
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    return (
                      <Row
                        gutter={[12, 12]}
                        key={key}
                        align="middle"
                        style={{ width: "100%", marginBottom: "10px" }}
                      >
                        {/* HSN */}
                        <Col xs={24} sm={12} md={6} lg={4}>
                          <Form.Item
                            {...restField}
                            name={[name, "hsnCode"]}
                            rules={[
                              { required: true, message: "Missing HSN Code" },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <Input placeholder="HSN Code" />
                          </Form.Item>
                        </Col>

                        {/* Description */}
                        <Col xs={24} sm={12} md={8} lg={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "description"]}
                            rules={[
                              {
                                required: true,
                                message: "Missing Product Descriptions",
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <Input placeholder="Product Description" />
                          </Form.Item>
                        </Col>

                        {/* Quantity + Unit */}
                        <Col xs={24} sm={12} md={6} lg={4}>
                          <Row gutter={6}>
                            <Col span={14}>
                              <Form.Item
                                {...restField}
                                name={[name, "quantity"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Quantity required",
                                  },
                                ]}
                                style={{ marginBottom: 0 }}
                              >
                                <InputNumber
                                  placeholder="Qty"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {}}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={10}>
                              <Form.Item
                                {...restField}
                                name={[name, "quantityUnit"]}
                                initialValue="Unit"
                                style={{ marginBottom: 0 }}
                              >
                                <Select>
                                  <Option value="Unit">Unit</Option>
                                  <Option value="Kg">Kg</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        {typeOfDocument !== "PACKING_LIST"? (
                          <>
                            {" "}
                            {/* Price */}
                            <Col xs={24} sm={12} md={4} lg={3}>
                              <Form.Item
                                {...restField}
                                name={[name, "price"]}
                                rules={[
                                  { required: true, message: "Price required" },
                                ]}
                                style={{ marginBottom: 0 }}
                              >
                                <InputNumber
                                  placeholder="Price"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {
                                    const quantity = form.getFieldValue([
                                      "users",
                                      name,
                                      "quantity",
                                    ]);

                                    form.setFieldValue(
                                      ["users", name, "amount"],
                                      value * quantity,
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            {/* Amount */}
                            <Col xs={24} sm={12} md={4} lg={3}>
                              <Form.Item
                                {...restField}
                                name={[name, "amount"]}
                                style={{ marginBottom: 0 }}
                              >
                                <InputNumber
                                  readOnly
                                  style={{ width: "100%" }}
                                  placeholder="Amount"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : (
                          <>
                            {" "}
                            {/* Price */}
                            <Col xs={24} sm={12} md={4} lg={3}>
                              <Form.Item
                                {...restField}
                                name={[name, "netWeight"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Net weight required",
                                  },
                                ]}
                                style={{ marginBottom: 0 }}
                              >
                                <InputNumber
                                  placeholder="Net Weight"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {}}
                                />
                              </Form.Item>
                            </Col>
                            {/* Amount */}
                            <Col xs={24} sm={12} md={4} lg={3}>
                              <Form.Item
                                {...restField}
                                name={[name, "grossWeight"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Gross weight required",
                                  },
                                ]}
                                style={{ marginBottom: 0 }}
                              >
                                <InputNumber
                                  placeholder="Gross Weight"
                                  style={{ width: "100%" }}
                                  onChange={(value) => {}}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}

                        {/* Remove */}
                        <Col xs={24} sm={6} md={2} lg={1}>
                          <Button
                            danger
                            type="default"
                            size="middle"
                            onClick={() => remove(name)}
                            icon={<DeleteOutlined style={{ fontSize: 20 }} />}
                            style={{
                              backgroundColor: "#C92A2A",
                              color: "white",
                              padding: "8px",
                              borderRadius: "6px",
                              width: "50px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                  <div className="flex justify-center mt-3">
                    <Form.Item>
                      <button
                        className="bg-cyan-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        type="button"
                        onClick={() => add()}
                        disabled={fields.length >= 5}
                      >
                        Add Product
                      </button>
                    </Form.Item>
                  </div>
                  -
                </>
              )}
            </Form.List>
          </div>
        </div>
        <div className="flex justify-center mt-3">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                border: "1px solid gray",
                color: "black",
                fontWeight: "bold",
              }}
            >
              Preview Invoice
            </Button>
          </Form.Item>
        </div>
      </Form>
      <Modal
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={900}
        bodyStyle={{ padding: 0 }}
        className="relative !p-0"
      >
        <PackingListPreview
          invoiceData={invoiceData}
          invoiceDate={invoiceDate}
          onEdit={handleEditInvoice}
        />
      </Modal>
    </div>
  );
};

export default Invoice;
